export enum PriceApprovalStatusEnum {
    RESET,
    PRICE_APPROVAL_REQUESTED,

    // atention: next values order matter, is used for approved projects table sorting
    PRICES_REJECTED,  //Abgelehnt
    PRICES_APPROVED,  //Freigegeben
}
